if (!window.__mobileAutoSlideshowInit) {
  window.__mobileAutoSlideshowInit = true;

  function cloneFirstSlide(container) {
    var track = container.querySelector(':scope > .group-block-content');
    if (!track) return;
    if (track.querySelector(':scope > .group-block[data-auto-slideshow-clone]')) return;

    var firstSlide = track.querySelector(':scope > .group-block');
    if (!firstSlide) return;

    var clone = firstSlide.cloneNode(true);
    clone.setAttribute('data-auto-slideshow-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('inert', '');
    track.appendChild(clone);
  }

  function init() {
    document.querySelectorAll('.mobile-auto-slideshow').forEach(cloneFirstSlide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}
